import React from 'react';

const Loader = () => {
  return (
    <div className="load-more_bars">
      <div className="load-more_bar"></div>
      <div className="load-more_bar"></div>
      <div className="load-more_bar"></div>
      <div className="load-more_bar"></div>
      <div className="load-more_bar"></div>
      <div className="load-more_bar"></div>
      <div className="load-more_bar"></div>
      <div className="load-more_bar"></div>
    </div>
  );
};

export default Loader;
